module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_close-87a11182867f094427b4d582d537c170.png";